import React from "react";
import "./SearchResult.css";
import { List, ListItem, ListItemIcon } from "@mui/material";
import { ReactComponent as DepartmentIcon } from "assets/DepartmentIcon.svg";
import { ReactComponent as ContentIcon } from "assets/ContentIcon.svg";
import { ReactComponent as BuildOutlined } from "assets/BuildOutlined.svg";

type SearchResult = {
  value: string;
  section: string;
  value_id: string;
};

type SearchResultProps = {
  results: SearchResult[];
  searchTerm: string;
};

const getIcon = (section: string) => {
  switch (section) {
    case "structure":
      return <BuildOutlined />;
    case "content":
      return <ContentIcon />;
    case "department":
      return <DepartmentIcon />;
    default:
      return null;
  }
};
const highlightText = (text: string, searchTerm: string) => {
  if (!searchTerm) return text;

  const regex = new RegExp(`(${searchTerm})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === searchTerm.toLowerCase() ? (
      <span key={index} className="highlight">
        {part}
      </span>
    ) : (
      part
    )
  );
};

const SearchResultComponent: React.FC<SearchResultProps> = ({
  results,
  searchTerm,
}) => {
  return (
    <List>
      {results.map((result) => (
        <div className="current-search-items" key={result.value_id}>
          <ListItem
            component="a"
            href={`/${result.section}/${result.value_id}`}
          >
            <div className="result-list-item">
              <div className="result-item-icon">
                <ListItemIcon>{getIcon(result.section)}</ListItemIcon>
              </div>
              <div className="result-item-content">
                <div className="result-item-title">
                  {highlightText(result.value, searchTerm)}
                </div>
                <div className="result-item-dsc">{result.section}</div>
              </div>
            </div>
          </ListItem>
        </div>
      ))}
    </List>
  );
};

export default SearchResultComponent;
